import React from 'react';

const Product = () => {
  const data = [
    {
      id: "01",
      title: "Web Applications",
      desc: "Unlock flexibility with our ERP software's intuitive web applications, granting seamless data access and management from any device, anywhere, anytime. Experience enhanced collaboration and productivity as your team stays connected on the go.",
      gradient: "linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)"
    },
    {
      id: "02",
      title: "Mobile Applications",
      desc: "Experience the freedom of managing your business data anytime, anywhere with our ERP software's mobile applications. Designed for seamless integration into your workflow.",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      id: "03",
      title: "Sales And Procurements",
      desc: "Revolutionize your supply chain operations with our advanced ERP software, designed to elevate sales and procurement management. Seamlessly integrate processes.",
      gradient: "linear-gradient(135deg, #2af598 0%, #009efd 100%)"
    },
    {
      id: "04",
      title: "Finance And HR",
      desc: "Empower your business with our integrated ERP software, delivering robust solutions for finance and HR management. Drive efficiency and compliance with our tailored tools.",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    }
  ];

  return (
    <div style={styles.section}>
      <div style={styles.headerArea}>
        <span style={styles.tagline}>Innovative Solutions</span>
        <h2 style={styles.heading}>What We Do Provide <span style={{color: '#4facfe'}}>PRODUCTS</span></h2>
      </div>

      <div style={styles.customGrid}>
        {data.map((item, index) => (
          <div key={index} style={styles.glassCard} className="hover-card">
            <div style={styles.topRow}>
              {/* નંબર હવે એકલો અને ક્લીન દેખાશે */}
              <span style={{...styles.number, color: item.gradient.split(' ')[4]}}>{item.id}</span>
            </div>
            <h3 style={styles.cardTitle}>{item.title}</h3>
            <p style={styles.cardText}>{item.desc}</p>
            {/* નીચેની ગ્રેડિયન્ટ લાઈન જે હોવર પર વધશે */}
            <div style={{...styles.bottomLine, background: item.gradient}}></div>
          </div>
        ))}
      </div>

      <style>
        {`
          .hover-card {
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            position: relative;
          }
          .hover-card:hover {
            transform: scale(1.02);
            background: rgba(255, 255, 255, 0.08) !important;
            box-shadow: 0 20px 50px rgba(0,0,0,0.5);
          }
          .hover-card:hover div:last-child {
            width: 100% !important;
          }
        `}
      </style>
    </div>
  );
};

const styles = {
  section: {
    backgroundColor: '#050505',
    padding: '100px 8%',
    fontFamily: "'Inter', sans-serif",
    color: '#fff',
    minHeight: '100vh'
  },
  headerArea: {
    textAlign: 'left',
    marginBottom: '80px',
    borderLeft: '4px solid #4facfe',
    paddingLeft: '25px'
  },
  tagline: {
    fontSize: '14px',
    textTransform: 'uppercase',
    letterSpacing: '5px',
    color: '#888'
  },
  heading: {
    fontSize: '45px',
    fontWeight: '900',
    margin: '10px 0'
  },
  customGrid: {
    display: 'grid',
    // અહીં ફેરફાર કર્યો છે: 2 કોલમ લેઆઉટ
    gridTemplateColumns: '1fr 1fr', 
    gap: '40px'
  },
  glassCard: {
    background: 'rgba(255, 255, 255, 0.03)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '30px 5px 30px 5px',
    padding: '40px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  topRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: '20px'
  },
  number: {
    fontSize: '32px',
    fontWeight: 'bold',
    opacity: 0.6
  },
  cardTitle: {
    fontSize: '24px',
    fontWeight: '700',
    marginBottom: '20px'
  },
  cardText: {
    color: '#aaa',
    lineHeight: '1.7',
    fontSize: '15px'
  },
  bottomLine: {
    height: '4px',
    width: '40px',
    marginTop: '30px',
    borderRadius: '2px',
    transition: '0.4s ease'
  }
};

export default Product;